<template>
  <div class="bind-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="filter-box">
          <div class="filter">
            <!-- <div class="filter-item">
              <div class="label">用户ID：</div>
              <el-input
                class="input"
                v-model="filter.uid"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div>
            <div class="btn-box">
              <button class="search" @click="search">筛选</button>
              <button class="reset" @click="reset">重置</button>
            </div> -->
          </div>
          <div>
            <!-- <button class="bind-btn" @click="bindModal">+ 账号绑定</button> -->
            <div class="code-box">
              <el-image
                class="img"
                :src="bindCodeImg"
                :preview-src-list="[bindCodeImg]"
              >
              </el-image>
              <span>管理员绑定微信<br />接收报修通知</span>
            </div>
          </div>
        </div>
        <el-table
          :data="userList"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column
            prop="uid"
            align="center"
            label="用户ID"
          ></el-table-column>
          <el-table-column
            prop="created"
            align="center"
            label="绑定时间"
          ></el-table-column>
          <el-table-column label="操作" align="center">
            <div slot-scope="scope">
              <button
                size="mini"
                class="table-btn"
                @click="handleClose(scope.row.uid)"
              >
                解除绑定
              </button>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <!-- <div class="footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div> -->
    </div>
    <el-dialog :visible.sync="bindShow" class="dialog" width="618px" top="25vh">
      <div slot="title" class="dialog-title">账号绑定</div>
      <el-form
        ref="form"
        :rules="rules"
        :model="bindForm"
        class="bind-form"
        label-width="auto"
      >
        <el-form-item label="用户ID：" prop="uid" class="form-item">
          <input
            placeholder="输入用户ID"
            class="input"
            v-model.number="bindForm.uid"
            type="number"
            placeholder-class="placeholder"
            onKeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))"
            oninput="value = /^\d+(\.{1}\d{0,2})?/g.exec(value) ? /^\d+(\.{1}\d{0,2})?/g.exec(value)[0] : ''"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="bindShow = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handlebind">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import dayjs from 'dayjs';
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'bind',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '用户管理',
        secondTitle: '订单提醒账号绑定'
      },
      filter: {
        // 过滤条件
        uid: null
      },
      userList: [], // 用户列表
      bindShow: false,
      rules: {
        uid: [{ required: true, message: '请输入用户ID', trigger: 'blur' }]
      },
      bindForm: {
        uid: null
      },
      bindCodeImg: ''
    };
  },
  filters: {
    // 时间格式化
    dateFormat(date) {
      if (!date) return '请选择时间';
      let day = dayjs(date);
      return day.format('YYYY-MM-DD HH:mm:ss');
    }
  },
  mounted() {
    // 获取列表
    this.getUserList();
    this.getBindCode();
  },
  computed: {},
  methods: {
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getUserList();
    },
    // 获取用户列表
    getUserList() {
      this.loading++;
      this.httpGet(this.$root.bindRemindList, {
        // page: this.currentPage,
        // size: this.size,
        ...this.filter
      }).then(
        (res) => {
          this.loading--;
          this.userList = res;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 过滤
    search() {
      console.log(this.filter);
      this.currentPage = 1;
      this.getUserList();
    },
    // 重置
    reset() {
      this.filter = {
        // 过滤条件
        uid: null
      };
      this.date = [];
      this.getUserList();
    },
    bindModal() {
      this.userDetail = {};
      this.bindForm = {
        uid: null
      };
      this.$refs.form && this.$refs.form.clearValidate();
      this.bindShow = true;
    },
    // 身份授权
    handlebind() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading++;
          this.httpPut(this.$root.bindRemind, this.bindForm).then(
            (res) => {
              this.loading--;
              this.bindShow = false;
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getUserList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
        }
      });
    },
    handleClose(uid) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要解除绑定吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPost(this.$root.unbindRemind, {
          uid
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getUserList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    getBindCode(hid, genre, name) {
      this.bindCodeImg = '';
      this.loading++;
      this.httpPost(this.$root.getBindCode, {
        page: 'pages/front/bind',
        scene: `a`
      }).then(
        (res) => {
          this.loading--;
          this.bindCodeImg = res.url;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.bind-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      // 按钮
      .btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin: 16px 0;
      }

      // 表格按钮
      .table-btn {
        // width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
        padding: 0 8px;
      }

      .filter-item {
        margin-right: 45px;
      }

      .select {
        width: 136px;
      }

      .input {
        width: 125px;
      }

      .date-input {
        width: 350px;
      }

      .btn-box {
        margin: 0;
        margin-left: -20px;
      }

      .bind-btn {
        confirm-btn();
        height: 32px;
        padding: 0 15px;
        white-space: nowrap;
      }

      .code-box {
          height: 50px;
          flex-x(center);
          // border: 1px solid #E8E8E8;
          padding: 10px;
          box-sizing: border-box;
          border-radius: 5px;
          background: #E6456A;

          .img {
            width: 30px;
            height: 30px;
            margin-right: 10px;
          }

          span {
            word(12, #fff);
            line-height: 18px;
          }
        }

      .table {
        margin-top: 24px !important;
      }
    }
  }

  .footer {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    flex-x(flex-end);
    background: white;
  }

  .dialog-content {
    flex-y();
  }

  .bind-form {
    padding: 16px 0 16px 120px;

    .input {
      width: 220px;
      height: 40px;
      line-height: 40px;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      padding: 0 15px;
      color: gray9;

      &::placeholder {
        /* WebKit browsers */
        color: #ccc;
      }
    }

    .search-btn {
      display: inline-block;
      confirm-btn();
      width: 72px;
      height: 32px;
      line-height: 32px;
      margin: 0 12px;
    }
  }
}
</style>
